export default __webpack_public_path__ + "static/media/wallet.bacc9e00.svg";